module.exports = __webpack_public_path__ + "img/toutiao.97f6f1e7.jpg";